<template>
  <validation-form @on-submit="updateAccount">
    <div id="student-information isis-page">
      <div class="fixed-plugin change-pwd">
        <button-change-password
          @showChangePasswordModal="showChangePasswordModal()"
        >
        </button-change-password>
      </div>
      <change-password
        :name="changePasswordModal.name"
        :title="changePasswordModal.title"
        :uuid="info.uuid"
      ></change-password>

      <div class="md-layout">
        <div class="md-layout-item md-xsmall-size-100">
          <md-card>
            <md-card-content class="p-4">
              <p class="font-medium text-lg">{{ info.full_name }}</p>
              <p class="font-normal text-base">
                {{ info.student_code }}
              </p>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-xsmall-size-100">
          <Avatar
            :defaultUrl="info.avatar_url || '/img/avt_placeholder.jpg'"
            :s3FolderPath="s3StudentsAvatarPath"
            @on-upload-s3-success="onUploadS3Success"
          />
        </div>
        <div class="md-layout-item hidden md:block"></div>
      </div>
      <div class="md-layout mt-4">
        <student-information-tabs
          ref="infoRef"
          :path="path"
        ></student-information-tabs>
      </div>
    </div>
  </validation-form>
</template>

<script>
import { Message, getId } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";
import AWSConst from "@/constants/AWS";
import Avatar from "@/components/Base/Avatar";
import { mapState } from "vuex";
import { forbidden_router_name, dashboard_router_name } from "@/routes/routes";
import StudentInformationTabs from "../Students/AccountDetail/Tabs";
import ChangePassword from "../ChangePassword";
import ButtonChangePassword from "@/components/Base/ButtonChangePassword.vue";

export default {
  name: "student-profile",
  components: {
    ChangePassword,
    StudentInformationTabs,
    Avatar,
    ButtonChangePassword
  },
  data() {
    return {
      path: service_paths.students,
      studentData: {},
      s3StudentsAvatarPath: `${AWSConst.S3_STUDENTS_UPLOAD_PATH}/avatars`,
      changePasswordModal: {
        name: "change-password",
        title: "student.change_password"
      }
    };
  },
  computed: {
    ...mapState("user", ["info"]),

    verifyUser() {
      return getId(this.info) === this.studentId;
    },

    studentId() {
      return this.$route.params.id;
    }
  },
  created() {
    this.getStudentData();
    if (!this.verifyUser) {
      this.$router.push({ name: forbidden_router_name });
    }
  },
  methods: {
    goToDashboard() {
      this.$router.push({ name: dashboard_router_name });
    },

    showChangePasswordModal() {
      this.$modal.show(this.changePasswordModal.name);
    },

    updateAccount() {
      this.$refs.infoRef.updateAccount();
    },

    updateStudentData(formData) {
      const errMsg = this.$t("common.form_invalid");
      return this.$axios
        .put(`${this.path}/${this.studentId}`, formData, true, {}, errMsg)
        .then(({ data }) => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },

    onUploadS3Success(savedLink) {
      const data = {
        avatar_url: savedLink
      };

      this.$axios.put(`${this.path}/${this.studentId}`, data).then(() => {
        Message.success(this.$t("common.update_avatar_success"));
      });
    },

    getStudentData() {
      return this.$axios
        .get(`${this.path}/${this.studentId}`)
        .then(({ data }) => {
          this.$refs.infoRef.setFormData(data);
          this.studentData = Object.assign({}, this.studentData, data);
        });
    }
  },
  provide() {
    return {
      fetchStudentData: this.getStudentData,
      updateStudentData: this.updateStudentData
    };
  }
};
</script>
